module.exports = __webpack_public_path__ + "img/index_04_pic_03@2x.16ea0bcf.png";